import { Grid } from '@mui/material';
import toolbarIconsList from './toolbarIconsList';
// import { Box } from 'mdi-material-ui';
// import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import useOnClickListener from './useOnClickListener';
import { createPortal } from 'react-dom';
import FloatingLinkEditor from './FloatingLinkEditor';
import { useIsMobile } from '../../../../hooks/misc';
// import { InsertImageDialog } from '../CustomPlugins/ImagePlugin';

const LexicalEditorTopBar = () => {
  const { onClick, selectedEventTypes, blockType, isLink, editor, modal } =
    useOnClickListener();

  const isIconSelected = (plugin) =>
    selectedEventTypes.includes(plugin.event) ||
    blockType.includes(plugin.event);
    const isMobile = useIsMobile();

  return (
    <div
      style={{
      display: 'flex',
      gap: '0.5rem',
      flexWrap: isMobile ? 'wrap' : 'nowrap',
      }}
    >
      {toolbarIconsList.map((plugin) => (
        <Grid
          key={plugin.id}
          sx={{
            cursor: 'pointer',
          }}
          item
        >
          {
            <plugin.Icon
              sx={{
                ...plugin.iconSx || {},
                color: isIconSelected(plugin) ? '#0d6efd' : '#0b1833',
                fontSize: '1.5rem',
              }}
              onClick={() => {onClick(plugin.event)}}
            />
          }
        </Grid>
      ))}
      {modal}
      {isLink &&
        createPortal(<FloatingLinkEditor editor={editor} />, document.body)}
    </div>
  );
};

export default LexicalEditorTopBar;